import { useRef, useState } from "react";
import { Check, Copy } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ButtonTip } from "@/components/ui/button-tip";
import { Input } from "@/components/ui/input";

/**
 * A link in a read-only field with a copy button. `navigator.clipboard` is missing on non-secure
 * origins, so the fallback selects the text for a manual copy.
 */
export default function CopyLinkBox({ link }: { link: string }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("no clipboard");
      await navigator.clipboard.writeText(link);
      setCopied(true);
    } catch {
      inputRef.current?.select();
      try {
        setCopied(document.execCommand?.("copy") ?? false);
      } catch {
        setCopied(false);
      }
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Input ref={inputRef} readOnly value={link} aria-label="Link für den Kunden" onFocus={(event) => event.target.select()} />
      <ButtonTip label="Kopiert den Link in die Zwischenablage">
        <Button type="button" variant="outline" onClick={() => void copy()} className="shrink-0">
          {copied ? <Check className="mr-1 h-4 w-4" aria-hidden="true" /> : <Copy className="mr-1 h-4 w-4" aria-hidden="true" />}
          {copied ? "Kopiert" : "Kopieren"}
        </Button>
      </ButtonTip>
    </div>
  );
}
